












import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({ type: String, default: "最近在玩" }) public title;
  @Prop({ type: String, default: "" }) public toPath;
  @Prop({ type: Boolean, default: true }) public btnShow;

  public toLink() {
    this.$router.push(this.toPath);
  }
}
